import Vue from "vue";
import App from "./App.vue";
import CKEditor from "ckeditor4-vue/dist/legacy.js";

require("es6-promise").polyfill();

import router from "./router";

import store from "./store";

import {
  BootstrapVue,
  BIconTrashFill,
  BIconPlus,
  BIconArchiveFill,
  BIconHouseFill,
  BIconCreditCard,
  BIconThreeDots,
  BIconLockFill,
  BIconUnlockFill,
  BIconSearch,
  BIconInfo,
  BIconChevronDown,
  BIconArrowUpShort,
  BIconArrowDownShort,
  BIconArrowUpDown,
  BIconDownload,
} from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap-vue/dist/bootstrap-vue-icons.min.css";
Vue.use(BootstrapVue);
Vue.use(CKEditor);
Vue.component("BIconDownload", BIconDownload);
Vue.component("BIconArrowUpDown", BIconArrowUpDown);
Vue.component("BIconArrowUpShort", BIconArrowUpShort);
Vue.component("BIconArrowDownShort", BIconArrowDownShort);
Vue.component("BIconInfo", BIconInfo);
Vue.component("BIconChevronDown", BIconChevronDown);
Vue.component("BIconTrashFill", BIconTrashFill);
Vue.component("BIconArchiveFill", BIconArchiveFill);
Vue.component("BIconPlus", BIconPlus);
Vue.component("BIconHouseFill", BIconHouseFill);
Vue.component("BIconCreditCard", BIconCreditCard);
Vue.component("BIconThreeDots", BIconThreeDots);
Vue.component("BIconLockFill", BIconLockFill);
Vue.component("BIconUnlockFill", BIconUnlockFill);
Vue.component("BIconSearch", BIconSearch);

Vue.config.productionTip = false;

new Vue({
  router,
  store: store,
  render: (h) => h(App),
}).$mount("#app");
